import React, { forwardRef } from 'react';
import { BeautifulMentionNode } from 'lexical-beautiful-mentions';

import { MetricMentionComponent } from './MetricMentionComponent';

class MetricMentionNode extends BeautifulMentionNode {
  static getType() {
    return 'metricMention';
  }

  static clone(node) {
    return new MetricMentionNode(node.__trigger, node.__value, node.__data, node.__key);
  }

  static importJSON(serializedNode) {
    return new MetricMentionNode(
      serializedNode.trigger,
      serializedNode.value,
      serializedNode.data,
      serializedNode.key
    );
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'metricMention',
      trigger: this.__trigger,
      value: this.__value,
      data: this.__data
    };
  }

  createDOM() {
    const node = document.createElement('span');
    node.style.display = 'inline-flex';
    node.style.verticalAlign = 'middle';
    node.setAttribute('data-tooltip', this.getData().definition);

    return node;
  }

  // eslint-disable-next-line class-methods-use-this
  updateDOM() {
    return false;
  }

  component() {
    const nodeKey = this.getKey();

    const Component = forwardRef((props, ref) => (
      <MetricMentionComponent nodeKey={nodeKey} {...props} ref={ref} />
    ));

    return Component;
  }

  getTextContent() {
    return `${this.getTrigger()}${this.getValue()}`;
  }
}

export { MetricMentionNode };
